import {
  type SemesterConstructor,
  type SemesterForTable,
} from "#customTypes/composedTypes/semesterTypes"
import { type Uuid } from "#customTypes/globalTypes"

export class Semester {
  id: Uuid
  startDate: string
  endDate: string

  constructor(props: SemesterConstructor) {
    this.id = props.id
    this.startDate = props.startDate
    this.endDate = props.endDate
  }

  getSemesterForTable = (): SemesterForTable => ({
    id: this.id,
    startDate: this.startDate,
    endDate: this.endDate,
  })
}
